import FormHelperText from '@mui/material/FormHelperText';
import { Box } from '@mui/material';
import React, { FC, SyntheticEvent } from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { formatGroupContactCountSuffix } from 'src/components/GroupOptionLabel';
import SelectWithSearch from 'src/components/SelectWithSearch/view';
import { normalizeRuleValues } from '../../helpers';
import { Group, GroupFormData } from '../../types';

type GroupIdRuleValuesInputProps = {
  form: UseFormReturn<GroupFormData>;
  fieldName: `rules.${number}.values`;
  customGroups: Group[];
};

export const GroupIdRuleValuesInput: FC<GroupIdRuleValuesInputProps> = ({
  form,
  fieldName,
  customGroups,
}) => {
  return (
    <Controller<GroupFormData, `rules.${number}.values`>
      name={fieldName}
      control={form.control}
      rules={{
        validate: value =>
          normalizeRuleValues(Array.isArray(value) ? value : []).length > 0 ||
          'Value is required',
      }}
      render={({ field, fieldState }) => {
        const currentValues = normalizeRuleValues(Array.isArray(field.value) ? field.value : []);
        const knownGroupIds = new Set(customGroups.map(group => group.id));
        const options = [
          ...customGroups.map(({ name, id, validContactCount }) => ({
            text: name || '',
            secondaryText: formatGroupContactCountSuffix(validContactCount),
            value: id,
          })),
          ...currentValues
            .filter(id => !knownGroupIds.has(id))
            .map(id => ({
              text: 'Unavailable group',
              value: id,
              isHidden: true,
            })),
        ];

        const handleSelectChange = (
          _: SyntheticEvent<Element, Event> | undefined,
          items: { text: string; value: string }[],
        ) => {
          field.onChange(items.map(item => item.value));
        };

        return (
          <Box mt={1} mb={0.5}>
            <SelectWithSearch
              label="Groups"
              placeholder={currentValues.length ? '' : 'Select groups'}
              options={options}
              values={currentValues}
              handleSelectChange={handleSelectChange}
              style={{ width: '100%' }}
              size="small"
            />
            {fieldState.error?.message && (
              <FormHelperText error>{fieldState.error.message}</FormHelperText>
            )}
          </Box>
        );
      }}
    />
  );
};
